(function() {
  'use strict';

  function config() {

    // PouchDB.plugin(Validation);
  }

  angular
    .module('blocks.db', [])
    .config(config);
})();
